import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PlayIcon } from '@fronton/icons-react';
import { root, active } from './styles';
import { cx } from 'linaria';
import { IconButton } from 'fronton-react';

const DATA_QA_PLAY_VIDEO_ICON = 'play-video-icon';
export const DATA_QA_PLAY_VIDEO = 'play-video';

type Props = {
  isActive: boolean;
  onClick: () => void;
};

const PlayVideo: FC<Props> = ({ isActive, onClick }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t('media-gallery.video.to-video-aria-label')}
      data-qa={DATA_QA_PLAY_VIDEO}
      className={cx(root, isActive && active)}
      onClick={onClick}
      size="s"
      invert={isActive}
    >
      <PlayIcon type="fill" size="s" data-qa={DATA_QA_PLAY_VIDEO_ICON} />
    </IconButton>
  );
};

export { PlayVideo };
